import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
import { addStyleSheetToElements } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/cssstylesheet-interface.js';
import { addTemplateMarkupToElements } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/template-interface.js';
import styles from './image-thumbnail.scss.js';
import contentBlockStyles from './content-block.scss.js';
import headingLinkStyles from './heading-links.scss.js';
import nestedContentBlockStyles from './nested-content-block.scss.js';
import contentBlockTemplate from './content-block.js';
/**
 * @element cipublic-image-thumbnail
 */
export class ImageThumbnail extends CipublicElement {
    constructor() {
        super(...arguments);
        /**
         * Set columns for multicol spread.
         */
        this.columns = 1;
        this.headingLinks = [];
        /**
         * Indicate if the list is ordered or unordered.
         */
        this.type = 'unordered';
        /**
         * Determine style variants.
         */
        this.variant = 'default';
        this.hasHr = false;
    }
    connectedCallback() {
        var _a;
        super.connectedCallback();
        // gives enough time for children to be defined
        this.initialChildren = Array.from(this.children).filter((element) => {
            return !(element.nodeName === 'SLOT') && !element.slot;
        });
        const nestedContentBlocks = [];
        (_a = this.initialChildren) === null || _a === void 0 ? void 0 : _a.forEach((contentBlock) => {
            var _a;
            contentBlock.setAttribute('variant', this.variant);
            if (contentBlock.querySelector('cipublic-content-block')) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                nestedContentBlocks.push(contentBlock.querySelector('cipublic-content-block'));
            }
            (_a = this.headingLinks) === null || _a === void 0 ? void 0 : _a.push(contentBlock.querySelector('[slot="heading"] cipublic-link'));
        });
        addTemplateMarkupToElements(this.initialChildren, contentBlockTemplate());
        addStyleSheetToElements(this.initialChildren, contentBlockStyles);
        addStyleSheetToElements(this.headingLinks, headingLinkStyles);
        if (nestedContentBlocks.length !== 0) {
            addStyleSheetToElements(nestedContentBlocks, nestedContentBlockStyles);
        }
    }
    render() {
        var _a, _b;
        return this.type === 'ordered'
            ? html `<slot></slot><slot name="heading"></slot><slot name="sub-heading"></slot><ol>${(_a = this.initialChildren) === null || _a === void 0 ? void 0 : _a.map((child) => {
                return html `<li>${child}</li>`;
            })}</ol>`
            : html `<slot></slot><slot name="heading"></slot><slot name="sub-heading"></slot><ul>${(_b = this.initialChildren) === null || _b === void 0 ? void 0 : _b.map((child) => {
                return html `<li>${child}</li>${this.hasHr ? html `<hr>` : ''}`;
            })}</ul>`;
    }
}
ImageThumbnail.styles = styles;
__decorate([
    property({ reflect: true, type: Number })
], ImageThumbnail.prototype, "columns", void 0);
__decorate([
    property({ reflect: true })
], ImageThumbnail.prototype, "type", void 0);
__decorate([
    property({ reflect: true })
], ImageThumbnail.prototype, "variant", void 0);
__decorate([
    property({ type: Boolean, attribute: 'has-hr' })
], ImageThumbnail.prototype, "hasHr", void 0);
//# sourceMappingURL=image-thumbnail.js.map